import { connect } from 'react-redux';
import BlockWrapper from '../components/block-wrapper';
import {
  publishToSAP,
  markDateConfirmed,
  deletePlanning,
  fetchBlockData,
  fetchBlockDataSuccess,
  updateBlockId,
  updateBlockOperationInfo,
  splitBlock,
  markDateUnconfirmed,
  restoreBackup,
  recalculateTravelTime,
} from '../../../containers/gantt-actions';

const mapStateToProps = state => ({
  ganttDimensions: state.gantt.ganttDimensions,
  viewDimensions: state.gantt.viewDimensions,
  dateReference: state.gantt.dateReference,
  view: state.gantt.view,
  isDoingAction: state.gantt.isDoingAction,
  isDraggingOver: state.gantt.isDraggingOver,
  planningAndViewToOpen: state.gantt.planningAndViewToOpen,
});

const mapDispatchToProps = {
  publishToSAP,
  markDateConfirmed,
  splitBlock,
  deletePlanning,
  fetchBlockData,
  fetchBlockDataSuccess,
  updateBlockId,
  updateBlockOperationInfo,
  markDateUnconfirmed,
  restoreBackup,
  recalculateTravelTime,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlockWrapper);
